import { Component } from "@angular/core";
import { Input } from "@angular/core";

@Component({
    selector: 'no-data',
    templateUrl: './noData.component.html',
    standalone: false
})
export class NoDataComponent {
    @Input() public message: string = "No hay datos";
}